import { useCallback, useState } from 'react'
import type { User } from '@supabase/supabase-js'
import { supabase } from '../lib/supabase'
import { FIRST_RUN_KEY, readFirstRun, type FirstRun } from '../lib/firstRun'

// Where this account's first run stands (lib/firstRun.ts), kept in its user
// metadata so another phone carries on from here. A save shows at once and is
// written behind it; one that fails is no reason to stop (the next one writes
// the whole run again). An account without a first run is never given one.

export function useFirstRun(user: User | null) {
  const [local, setLocal] = useState<{ userId: string; run: FirstRun } | null>(null)
  const fromAccount = readFirstRun(user?.user_metadata)
  const firstRun = local && local.userId === user?.id ? local.run : fromAccount

  const save = useCallback((patch: Partial<Omit<FirstRun, 'v'>>) => {
    if (!user || !firstRun) return
    const run: FirstRun = { ...firstRun, ...patch, v: 1 }
    setLocal({ userId: user.id, run })
    void supabase.auth.updateUser({ data: { [FIRST_RUN_KEY]: run } }).catch(() => { /* carries on locally */ })
  }, [user, firstRun])

  return { firstRun, save }
}
